/* @flow */
import type { ContestType } from '../../redux/types';

const themeMap = {
  pizza: 'pizza',
  ice: 'ice',
  sushi: 'sushi',
  'ice-a': 'ice',
  'pizza-a': 'pizza',
  'sushi-a': 'sushi',
};
export function themeOf(contest: ContestType) {
  return themeMap[contest];
}

type Dict<T: { [string]: string }> = {
  _: T,
  [ContestType]: $Shape<T>,
};
type Translate<T> = (contestType: ContestType, key: $Keys<T>) => string;
export const makeT = function<T: { [string]: string }>(dict: Dict<T>): Translate<T> {
  return (contestType, key) => {
    if (dict[contestType] && dict[contestType][key]) return dict[contestType][key];
    return dict._[key];
  };
};
